import { ContractProvider } from '../admin/plan-versions/plan-version.type';
import { PlanVersionAngeplusButton } from './PlanVersionAngeplusButton';
import { PlanVersionGsadminButton } from './PlanVersionGsadminButton';

type CardPlanVersionPrimaryButtonProps = {
  planVersionId: string;
  contractProvider?: ContractProvider;
};

export const CardPlanVersionPrimaryButton = (
  props: CardPlanVersionPrimaryButtonProps,
) => {
  if (props.contractProvider === 'angeplus') {
    return <PlanVersionAngeplusButton planVersionId={props.planVersionId} />;
  }

  return <PlanVersionGsadminButton planVersionId={props.planVersionId} />;
};
